import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Row, Col, Container, Carousel, CarouselControl, CarouselIndicators, CarouselIndicator, CarouselInner} from "mdbreact";
import {Link} from "react-router-dom";
import {API_URL} from "../../config/Config";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios/index";
import ProductComplate from "../../components/product/ProductComplate";
import CarouselRowGrouping from "../../components/carousel/CarouselRowGrouping";

export default class ProductDetail extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.state = {
            activeItem: 1,
            maxLength: 4,
            product:{},
            populars:[],
            popularsChanked:[],
            rowCount:1,
        };


    }
    componentDidMount(){
        const { params } = this.props.match;
        axios.get(`${API_URL}product/?id=${params.id}`)
            .then(res => {
                if (res.data.status === 1){
                    const product = res.data.data;
                    const populars = res.data.populars.map(obj => obj);
                    const rowCount = populars.length;
                    let popularsChanked = [];
                    let rowItems = [];

                    populars.forEach((pop, i) =>{
                        rowItems.push(pop);

                        if(((i+1) % 3 === 0) || ((i+1) === rowCount)){
                            popularsChanked.push(rowItems);
                            rowItems = [];
                        }

                    });
                    console.log(popularsChanked);

                    this.setState({ product,populars,rowCount,popularsChanked, ready:true });
                }else{
                    toast.error(res.data.message,{
                        autoClose: 3000,
                        position: toast.POSITION.TOP_RIGHT,
                        rtl:true
                    });
                }
            });
    }
    next() {
        let nextItem = this.state.activeItem + 1;
        if(nextItem > this.state.maxLength) {
            this.setState({ activeItem: 1 });
        } else {
            this.setState({ activeItem: nextItem });
        }
    }

    prev() {
        let prevItem = this.state.activeItem - 1;
        if(prevItem < 1) {
            this.setState({ activeItem: this.state.maxLength });
        } else {
            this.setState({ activeItem: prevItem });
        }
    }

    goToIndex(item) {
        if (this.state.activeItem !== item) {
            this.setState({
                activeItem: item
            });
        }
    }


    render() {
        const { product,activeItem } = this.state;

        return (

            <div >
                <div className="jumbotron text-center rtl">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title">{product.title}</h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                <BreadcrumbItem><Link to="/products">محصولات</Link></BreadcrumbItem>
                                <BreadcrumbItem active>{product.title}</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    <div className="row">
                        <div className="col-sm-12" style={{minHeight:500}}>
                            <ProductComplate  productObj={product}/>
                        </div>
                        <ToastContainer
                            hideProgressBar={true}
                            newestOnTop={true}
                            autoClose={5000}
                        />
                    </div>
                </div>

                <div className="most_popular" style={{ padding: "60px 0 0",backgroundColor: '#f1f1f1',borderTop: '2px solid #f6581d'}}>
                    <div className="container">

                        <Row className="stories-header" data-auto-height="true">
                            <Col md="12">
                                <h2 className="text-center underline">محبوب ترین ها</h2>
                            </Col>
                        </Row>

                        <Row>
                                <Container>
                                    <Carousel activeItem={this.state.activeItem} next={this.next} className="merchant-popular-list mt-5 mb-5">
                                        <CarouselInner>
                                            {this.state.popularsChanked.map((popArray,index) =>
                                                <CarouselRowGrouping key={index+1} items={popArray} itemIndex={index+1}/>
                                            )}
                                        </CarouselInner>
                                        <CarouselControl direction="prev" role="button" onClick={() => { this.prev(); }} />
                                        <CarouselControl direction="next" role="button" onClick={() => { this.next(); }} />
                                        <CarouselIndicators>
                                            {this.state.popularsChanked.map((pArray,i) =>
                                                <CarouselIndicator active={activeItem === (i+1) ? true : false} onClick={() => { this.goToIndex(i+1); }}></CarouselIndicator>
                                            )}
                                        </CarouselIndicators>
                                    </Carousel>
                                </Container>
                        </Row>
                        <Row className="mt-5 pb-5 justify-content-center">
                            <Link to="/merchantList" className="btn btn-outline-warning waves-effect font-weight-bold">مشاهده همه مراکز طرف قرارداد ما</Link>
                        </Row>
                    </div>
                </div>
                <div className="clearfix">
                    <Container className="mt-5">
                        <Row className="stories-header" data-auto-height="true">
                            <Col md="12">
                                <h2 className="text-center underline">مزایای عضویت </h2>
                            </Col>
                        </Row>
                      <Row className="mt-3 rtl">
                          <Col md='3' ms='6' className="benefit-item">
                              <div className="mt-widget-2 member-benefit">

                                  <div className="mt-head">
                                      <div className="mt-head-label bg-white padding-5">
                                          <img src="./../../assets/images/icon/icon_ticket.png" style={{width:30}} alt="  "/>
                                      </div>
                                      <div className="mt-head-user">
                                          <img src="./../../assets/images/member/monthlyOffer.jpg" alt="Monthly Offers"
                                               width="100%"/>
                                      </div>
                                  </div>
                                  <div className="mt-body">
                                      <h3 className="mt-body-title"> Monthly Offers </h3>
                                      <p>Exclusive access to special 2-for-1 and discount offers, including brunches,
                                          theme nights, buffets and more, every month.</p>
                                  </div>
                              </div>
                          </Col>

                          <Col  md='3' ms='6' className="benefit-item">
                              <div className="mt-widget-2 member-benefit">
                                  <div className="mt-head">
                                      <div className="mt-head-label bg-white padding-5">
                                          <img src="./../../assets/images/icon/icon_hotel.png" style={{width:30}} alt='  '/>
                                      </div>
                                      <div className="mt-head-user">
                                          <img src="./../../assets/images/member/travel_img.jpg" alt="Travel Offers"
                                               width="100%"/>
                                      </div>
                                  </div>
                                  <div className="mt-body">
                                      <h3 className="mt-body-title"> Travel Offers</h3>
                                      <p>Exclusive discounts at over 550,000 hotels, with our new <b>getaways</b> feature.
                                          Plus, more than 500 Buy One Night Get One Free offers with <b>Hotels
                                              Worldwide</b>. </p>
                                  </div>
                              </div>
                          </Col>

                          <Col  md='3' ms='6' className="benefit-item">
                              <div className="mt-widget-2 member-benefit">
                                  <div className="mt-head">
                                      <div className="mt-head-label bg-white padding-5">
                                          <img src="./../../assets/images/icon/icon_shopping.png" style={{width:30}}  alt='  '/>
                                      </div>
                                      <div className="mt-head-user">
                                          <img src="./../../assets/images/member/goods.jpg" alt="Goods" width="100%"/>
                                      </div>
                                  </div>
                                  <div className="mt-body">
                                      <h3 className="mt-body-title"> Goods </h3>
                                      <p>Our brand new shopping platform with great prices and even more discounts when
                                          you use your Smiles. </p>
                                  </div>
                              </div>
                          </Col>

                          <Col  md='3' ms='6' className="benefit-item">
                              <div className="mt-widget-2 member-benefit">
                                  <div className="mt-head">
                                      <div className="mt-head-label bg-white p-1">
                                          NEW
                                      </div>
                                      <div className="mt-head-user">
                                          <img src="./../../assets/images/member/newOffers.jpg" alt="New Offers" width="100%"/>
                                      </div>
                                  </div>
                                  <div className="mt-body">
                                      <h3 className="mt-body-title"> New Offers </h3>
                                      <p>Enjoy additional savings with new outlets added to your DOTAYEKI throughout the
                                          year. </p>
                                  </div>
                              </div>
                          </Col>

                      </Row>
                    </Container>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/products/ProductDetail.js